module.exports = __webpack_public_path__ + "static/media/bing.089df82d.png";